import React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import HouseholdEligibilityGroups from '../../../components/individualPortal/dashboard/HouseholdEligibilityGroups';
import Tooltip from '../../../components/common/tooltip/Tooltip';
import {
    APP_STATUSES,
    ELIGIBILITY_STATUSES,
    ELIGIBILITY_INDICATORS,
    VERIFICATION_STATUSES,
    DMI_DOCUMENT_UPLOAD_STATUS
} from '../../../constants/individualPortal/dashboard/dashboardModelTypes';
import { FormattedMessage } from 'react-intl/dist';
import { ctaHandlers } from '../../../utils/dashboard/stateSpecificUtils';
import { STATE_NAMES } from '../../../constants/configs/states';
import { configs } from '../../../constants/configs/configs';

import { showModal } from '../../../actions/common/actionCreators';
import {
    checkActiveEnrollment,
    cloneApplication
} from '../../../actions/individualPortal/dashboard/dashboardActionCreators';
import { renderAmount } from '../../../utils/dashboard/processCommon';


const HouseholdEligibilityContainer = props => {
    const {
        actions,
        environment: {
            isState,
            stateCode,
            user,
            links: {
                CALHEERS_URL,
                PHONE
            },
            ssapFlowVersion,
            flags: {
                multiHouseholdEnabled,
                isQleMultipleDocumentSupport,
            },
            language,
        },
        dashboardModels,
        activeTab,
        history
    } = props;

    const CSR_ELIGIBLE = 'csrEligible';
    const APTC_ELIGIBLE = 'aptcEligible';
    const STATE_SUBSIDY = 'stateSubsidyEligible';
    
    const activeTabData = dashboardModels[activeTab];
    const {
        applicationYear,
        applicationStatus, 
        applicants,
        stateSubsidy,
        preEligibility, 
        isInsideOEWindow,
        isFinancial,
        openApplication,
        verificationStatus,
        dmiDocumentUploadstatus,
        encryptedCaseNumber,
        encryptedApplicationId,
        isLocked
    } = activeTabData;


    let applicantByTaxHouseholdGroup = [];
    if(applicants !== null) {
        applicantByTaxHouseholdGroup = Object.values(applicants.reduce((acc, x) => {
            acc[x.taxHouseholdGroup] = [...(acc[x.taxHouseholdGroup] || []), x ];
            return acc;
        }, {}));
        const sorted = true;
        applicantByTaxHouseholdGroup.sort(function(a, b) {
            if (!a[0].taxHouseholdGroup) { return -1; }

            if (!b[0].taxHouseholdGroup) { return +1; }

            if (sorted)
                return a[0].taxHouseholdGroup.localeCompare(b[0].taxHouseholdGroup);
            else
                return b[0].taxHouseholdGroup.localeCompare(a[0].taxHouseholdGroup);
        }).reverse();
    }

    const preAPTC = preEligibility && preEligibility.aptcEligible;
    const preCSR = preEligibility && preEligibility.csrEligible;
    const isPreEligibility = preAPTC || preCSR;
    const householdCaseId = user && user.householdCaseId;

    const caseNumber = openApplication ? openApplication.caseNumber : activeTabData.caseNumber;
    const ssapApplicationId = openApplication ? openApplication.ssapApplicationId : activeTabData.ssapApplicationId;

    const ssapParams = { ssapFlowVersion, caseNumber, applicationStatus, applicationYear, isInsideOEWindow, isFinancial, ssapApplicationId, encryptedApplicationId };
    const { goToUploadDocs, goToReportAChange } = ctaHandlers;
    
    const viewDetailsCb = () => goToEligibilityResults(CALHEERS_URL, householdCaseId);
    const reportAChangeCb = () => goToReportAChange(stateCode, ssapParams, CALHEERS_URL, householdCaseId, actions);
    const uploadDocsCb = () => goToUploadDocs(history, caseNumber, language, isQleMultipleDocumentSupport);

    const goToEligibilityResults = ( CALHEERS_URL, householdCaseId) => {
        if (isState.CA) {
            window.location = configs.externalEndpoints.CA_LINKS.CA_ELIGIBILITY.processReplacements({ CALHEERS_URL, householdCaseId });
        } else {
            history.push(
                configs.routes.ELIGIBILITY_RESULTS,
                {
                    prevLocation: configs.routes.INDPORTAL,
                    encryptedCaseNumber: encryptedCaseNumber
                }
            );
        }
    };
    
    const CTA_Link = ({ id, className, text, cb, href='#' }) => {

        const onClickHandler = (e) => {
            href ==='#' && e.preventDefault();
            cb();
        };

        return (
            <a
                id={id}
                className={`text-underline ${className}`}
                href={href}
                onClick={onClickHandler}
            >
                {<FormattedMessage id={text}/>}
            </a>
        );
    };


    /**
     * Retunrs CTA links (column 3).
     * @returns {*}
     * @constructor
     */
    const HouseholdCTA = () => {
        return (
            <div className="tablet:grid-col-3 padding-2">
                <CTA_Link
                    id="household_elig_link"
                    className='household-eligibility_link'
                    text="household_section.eligibility.cta.view_details"
                    cb={viewDetailsCb}
                />
                <br/>

                { !isLocked &&
                    <CTA_Link
                        id="household_report_change_link"
                        className='household-eligibility_link'
                        text={'household_section.eligibility.cta.edit_application'}
                        cb={reportAChangeCb}
                    />
                }


                <br/>

                {multiHouseholdEnabled &&
                    <CTA_Link
                        id="household_other_tax_households"
                        className='household-eligibility_link'
                        text="household_section.eligibility.cta.multihousehold"
                        href={configs.routes.MULTI_HOUSEHOLD_DETAILS}
                    />
                }

            </div>);
    };

    /**
     * Helper function to get FormattedMessage.
     * @param id
     * @param values
     * @param tagName
     * @returns {*}
     */
    const formatMessage = (id, values, tagName) => <FormattedMessage id={id} values={ values } tagName={ tagName }/>;

    const checkMemberEligibility = (flagName, applicants) => applicants.some(applicant => applicant[flagName] === true);


    /**
     * Returns conditional eligibility msg if isEligibilityConditional is true and application status is not closed.
     * @returns {*|boolean}
     */
    const getConditionEligibilitySection = () => {
        return verificationStatus === VERIFICATION_STATUSES.ACTION_NEEDED &&
            (dmiDocumentUploadstatus === DMI_DOCUMENT_UPLOAD_STATUS.PENDING || dmiDocumentUploadstatus === DMI_DOCUMENT_UPLOAD_STATUS.PROCESSING) &&
            applicationStatus !== APP_STATUSES.CL &&
            <span className="margin-left-2 text-red household-eligibility__conditional">
                <FormattedMessage id="household_section.eligibility_conditional"/>

                {
                    isState.PA &&

                    <Tooltip
                        {...{
                            id: 'label.conditional',
                            content: 'household_section.eligibility_conditional.tooltip',
                            dataAutomationId: 'household_eligibility_household_section_conditonal_tooltip'
                        }}
                    />
                }
                <CTA_Link
                    id="household_section.eligibility_conditional"
                    className='margin-left-1 text-semibold link'
                    text="household_section.more_details"
                    cb={uploadDocsCb}
                />
                <FormattedMessage id="household_section.upload_docs"/>
            </span>;
    };
    
    /**
     * Returns public program message if at least one member of the household is MedicaiD assessed or Chipassesed.
     */
    const showPublicProgramMessage = () => {
        if (isState.CA || isState.MN || isState.ID) {
            return false;
        } else {
            return applicants && applicants.some(applicant => applicant.assessedChipEligible ||
                applicant.assessedMedicaidMAGIEligible || applicant.assessedMedicaidNonMAGIEligible);
        }
    };

    /**
     * Each group shows corresponding indicators based on eligibility props.
     * @param applicant
     * @param group
     * @returns {{}}
     */
    const calculateIndicatorsByGroup = (applicant, group) => {
        const {
            chipEligible,
            nativeAmerican,
            assessedMedicaidMAGIEligible,
            assessedMedicaidNonMAGIEligible,
            assessedChipEligible,
            medicaidMAGIEligible,
            medicaidNonMAGIEligible,
            seekingCoverage,
            exchangeEligible,
            emergencyMedicaidEligible = false
        } = applicant;

        let indicators = [];

        switch (group) {
            case 3:
            case 2:
                (assessedMedicaidMAGIEligible || assessedMedicaidNonMAGIEligible) && indicators.push(formatMessage(ELIGIBILITY_INDICATORS.ASSESSED_MEDICAID));
                assessedChipEligible && indicators.push(formatMessage(ELIGIBILITY_INDICATORS.CHIP_ASSESSED));
                (medicaidMAGIEligible || medicaidNonMAGIEligible) && indicators.push(formatMessage(ELIGIBILITY_INDICATORS.MEDICAID));
                nativeAmerican && indicators.push(formatMessage(ELIGIBILITY_INDICATORS.AI_AN));
                emergencyMedicaidEligible && indicators.push(formatMessage(ELIGIBILITY_INDICATORS.POTENTIALLY_EMERGENCY_MEDICAID_ELIGIBLE));
                break;
            case 1:
                !seekingCoverage && indicators.push(formatMessage(ELIGIBILITY_INDICATORS.NOT_SEEKING_COVERAGE));
                (chipEligible && !exchangeEligible) && indicators.push(formatMessage(ELIGIBILITY_INDICATORS.CHIP));
                (assessedMedicaidMAGIEligible || assessedMedicaidNonMAGIEligible) && indicators.push(formatMessage(ELIGIBILITY_INDICATORS.ASSESSED_MEDICAID));
                assessedChipEligible && indicators.push(formatMessage(ELIGIBILITY_INDICATORS.CHIP_ASSESSED));
                (medicaidMAGIEligible || medicaidNonMAGIEligible) && indicators.push(formatMessage(ELIGIBILITY_INDICATORS.MEDICAID));
                emergencyMedicaidEligible && indicators.push(formatMessage(ELIGIBILITY_INDICATORS.POTENTIALLY_EMERGENCY_MEDICAID_ELIGIBLE));
        }
        return indicators;
    };

    /**
     * Returns only needed, filtered application data with precalculated indicators.
     * @param applicant
     * @param groupInd
     * @returns {{name: string, id: *, indicators: {}}}
     */
    const filterApplicantData = (applicant, groupInd) => {
        const {
            memberId,
            firstName,
            middleName,
            lastName,
            nameSuffix,
        } = applicant;

        return {
            id: memberId,
            name: `${firstName} ${middleName && middleName} ${lastName} ${nameSuffix && nameSuffix}`,
            indicators: calculateIndicatorsByGroup(applicant, groupInd)
        };
    };

    const populateMembers = (group, groupInd) => {
        if (!group || group.length < 0 ) return false;

        return group.reduce((acc, applicant) => {
            acc.push(filterApplicantData(applicant, groupInd));
            return acc;
        }, []);
    };
    

    const populateStatuses = (group, groupInd, aptc) => {

        const statuses = [];
        switch (groupInd) {
            case 1:
                statuses.push(formatMessage(ELIGIBILITY_STATUSES.NOT_ELIGIBLE_ENROLL));
                break;

            case 2:
                statuses.push(formatMessage(ELIGIBILITY_STATUSES.ELIGIBLE_QHP));
                
                // CSR
                checkMemberEligibility(CSR_ELIGIBLE, group) &&
                statuses.push(formatMessage(ELIGIBILITY_STATUSES.ELIGIBLE_CSR, { csrTooltip: 
                        <Tooltip 
                            id='household_section.eligibility.status.csr' 
                            content='household_section.tooltip_csr' 
                            index={groupInd} 
                        /> 
                }));
                break;

            case 3:
                // APTC
                if (aptc !== null && checkMemberEligibility(APTC_ELIGIBLE, group)) {
                    statuses.push(
                        <Tooltip
                            id={ELIGIBILITY_STATUSES.ELIGIBLE_APTC}
                            content='household_section.tooltip_aptc'
                            index={groupInd}
                        />
                    );
                    statuses.push(formatMessage('household_section.eligibility.status.eligible_amount', { amount: renderAmount(aptc) }, 'b'));
                }
                // State subsidy
                if (stateSubsidy !== null && checkMemberEligibility(STATE_SUBSIDY, group)) {
                    statuses.push(
                        <Tooltip
                            id={ELIGIBILITY_STATUSES.ELIGIBLE_SUBSIDY}
                            content='household_section.tooltip_state_subsidy'
                            index={groupInd}
                            dataAutomationId='state_subsidy_dashboard_household'
                        />
                    );
                    statuses.push(
                        <b data-automation-id='state_subsidy_dashboard_household_amount'>
                            <FormattedMessage
                                id='household_section.eligibility.status.eligible_amount'
                                values={{ amount: renderAmount(stateSubsidy) }}
                            />
                        </b>
                    );
                }
                
                // CSR
                checkMemberEligibility(CSR_ELIGIBLE, group) ?
                    statuses.push(formatMessage(ELIGIBILITY_STATUSES.ELIGIBLE_CSR_ANY_MEMBER, { csrTooltip:
                            <Tooltip 
                                id='household_section.eligibility.status.csr' 
                                content='household_section.tooltip_csr' 
                                index={groupInd} 
                            /> 
                    })): statuses.push(formatMessage(ELIGIBILITY_STATUSES.NOT_ELIGIBLE_CSR));
                break;
        }
        return statuses;
    };

    /**
     * Main function for distributing applicants into 3 groups.
     * @returns {[][]}
     */
    const createGroups = (applicants) => {
        if (!applicants || applicants.length < 0) return false;

        const group_1 = [];
        const group_2 = [];
        const group_3 = [];


        let aptcByGroup = applicants.reduce((accumulator, applicant) => {
            return accumulator + applicant.aptc;
        }, 0);

        applicants.map((applicant) => {
            const {
                aptcEligible,
                stateSubsidyEligible,
                exchangeEligible,
                seekingCoverage,
                chipEligible,
                medicaidMAGIEligibile,
                medicaidNonMAGIEligibile,
                assessedMedicaidMAGIEligible,
                assessedChipEligible,
                emergencyMedicaidEligible
            } = applicant;
            if (aptcEligible || stateSubsidyEligible) {
                group_3.push(applicant);
            }

            else if (exchangeEligible && !aptcEligible && !stateSubsidyEligible) {
                group_2.push(applicant);
            }

            else if (!seekingCoverage || !exchangeEligible ||
                chipEligible || medicaidMAGIEligibile || medicaidNonMAGIEligibile ||
                assessedMedicaidMAGIEligible || assessedChipEligible || emergencyMedicaidEligible) {
                group_1.push(applicant);
            }
        });
        const formattedGroups = [];

        [group_1, group_2, group_3].forEach((group, index) => {
            formattedGroups.push({
                members: populateMembers(group, index + 1),
                statuses: populateStatuses(group, index + 1, aptcByGroup)
            });
        });
        return formattedGroups;
    };


    const getHouseholdEligibility =  (applicants, index) => {
        let nonMemberITF = undefined;
        if (applicants) {
            nonMemberITF = applicants.map(applicant => applicant.taxHouseholdGroup === 'NON_ITF').includes(true);
        }

        switch (applicationStatus) {
            case APP_STATUSES.ER:
            case APP_STATUSES.PN:
            case APP_STATUSES.EN:
                return (
                    <div key={index} className="grid-row padding-2 household-eligibility-group__tax-group">
                        <HouseholdEligibilityGroups
                            groups={createGroups(applicants) && createGroups(applicants).slice(0).reverse()}
                        />
                        {
                            nonMemberITF && <HouseholdCTA />
                        }

                    </div>
                );

            case null:
            case APP_STATUSES.OP:
            case APP_STATUSES.CL:
                return (
                    <div key={index} className="grid-row padding-2 household-eligibility-group__tax-group">
                        <div className='grid-col-12 padding-x-2'>
                            {
                                isPreEligibility ? <FormattedMessage id="household_section.pre_eligibility"
                                    values={{
                                        preAPTC: preAPTC && <FormattedMessage id="household_section.preAPTC"/>,
                                        and: preAPTC && preCSR && <FormattedMessage id="common.and"/>,
                                        preCSR: preCSR && <FormattedMessage id="household_section.preCSR" />
                                    }} /> :
                                    <FormattedMessage id="household_section.default"/>
                            }
                        </div>
                    </div>
                );

            case APP_STATUSES.CC:
            case APP_STATUSES.UC:
            default:
                return (
                    <div key={index} className="grid-row padding-2 household-eligibility-group__tax-group">
                        <div className='grid-col-12 padding-x-2'>
                            <FormattedMessage id="household_section.default"/>
                        </div>
                    </div>
                );
        }
    };

    return (
        <div id="auto-household" className="household-eligibility gi-panel">
            <div className="grid-row">
                <h4 id="household_elig_header">
                    <FormattedMessage id="household_section.header"/>
                    { getConditionEligibilitySection() }
                </h4>

                { showPublicProgramMessage() &&
                    <div className="grid-col-12 padding-x-2">
                        <FormattedMessage id="household_section.public_program" tagName='p' values={{ stateName: STATE_NAMES[stateCode], phone: PHONE }}/>
                    </div>
                }
            </div>
            { Object.keys(applicantByTaxHouseholdGroup).length < 1 && getHouseholdEligibility(null, undefined) }
            { Object.keys(applicantByTaxHouseholdGroup).length > 0 && applicantByTaxHouseholdGroup.map((applicants, index) => getHouseholdEligibility(applicants, index)) }
        </div>
    );
};
const mapStateToProps = state => ({
    environment: state.common.environment,
    dashboardModels: state.individualPortal.dashboard.dashboardModels,
    activeTab: state.individualPortal.dashboard.activeTab
});

const mapDispatchToProps = dispatch => ({
    actions: bindActionCreators({
        showModal,
        checkActiveEnrollment,
        cloneApplication
    }, dispatch)
});


export default connect(mapStateToProps, mapDispatchToProps)(HouseholdEligibilityContainer);